import React, { useState, useEffect } from 'react';
import { useNavigate } from '@thd-olt-component-react/router';

export const useCompare = () => {
  let navigate = useNavigate();
  const [selectedForCompare, setSelectedForCompare] = useState([]);

  useEffect(() => {
    const itemIds = window.sessionStorage.getItem('compare');
    window.sessionStorage.removeItem('compare');
    if (itemIds) {
      setSelectedForCompare(JSON.parse(itemIds));
    }
  }, []);

  const onSelectedForCompare = (itemId, selected = false) => {
    if (selected) {
      setSelectedForCompare([...selectedForCompare, itemId]);
    } else {
      setSelectedForCompare(selectedForCompare.filter((id) => id !== itemId));
    }
  };

  const onCompare = () => {
    const queryParams = selectedForCompare
      .map((itemId, index) => `item${index + 1}=${itemId}`)
      .join('&');

    navigate(`/compare?${queryParams}`, { state: { bypassExperienceCheck: true } });
  }

  return {
    selectedForCompare,
    onSelectedForCompare,
    onCompare,
  }
};
